export default __webpack_public_path__ + "static/media/file-complete.3a3afd30.png";